var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass: "col-12 form-group form-group__animated",
        class: { "form-group--error": !_vm.validation.nip },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.value.nip,
              expression: "value.nip",
            },
          ],
          staticClass:
            "form-group__input form-group__input--paddings-classic form-group__animated__input",
          attrs: {
            type: "text",
            name: "nip",
            id: _vm.name + "-id-nip",
            placeholder: "Numer NIP",
          },
          domProps: { value: _vm.value.nip },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.value, "nip", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "form-group__animated__label",
            attrs: { for: _vm.name + "-id-nip" },
          },
          [_vm._v(_vm._s(_vm.$t("nip", "form_company_data")))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }